import { Component, forwardRef, Injector, Input, Output, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IOptionType } from '../models/ISelectOption';
import { AdSearchListComponent } from '../ad-search-list/ad-search-list.component';
import { FlexibleConnectedPositionStrategy } from '@angular/cdk/overlay';
import { AdMessageService } from '@internal/common-ui/ad-message';


const ADSELECT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AdSelectComponent),
  multi: true
}

const defaultGetLabel = (option) => {
  if (option == null) {
    return '';
  } else if (typeof option === 'string' || typeof option === 'number') {
    return `${option}`;
  } else if ('label' in option) {
    return option['label'];
  } else {
    return 'Please provide getLabel Function';
  }
}


@Component({
  selector: 'ad-select',
  templateUrl: './ad-select.component.html',
  styleUrls: ['./ad-select.component.scss'],
  providers: [ADSELECT_VALUE_ACCESSOR]
})
export class AdSelectComponent implements ControlValueAccessor {
  @Input() inputTemplate: TemplateRef<any>;
  @Input() listItemTemplate: TemplateRef<any>;
  @Input() expandIcon: string;
  @Input() collapseIcon: string;
  @Input() iconPos: 'left' | 'right' = 'right';
  @Input() options: { label?: string }[] | string[] | number[];
  @Input() getLabel: (option?: IOptionType) => string = defaultGetLabel;
  @Input() placeHolder: string = 'Please select';

  value: IOptionType;
  disabled: boolean;
  get isSelected() {
    return this.value != null;
  }
  onChange: Function = () => { };
  onTouch: Function = () => { };

  panel: ControlValueAccessor;
  isPanelOpen: boolean;
  rootNode: HTMLDivElement;
  positionStragety: FlexibleConnectedPositionStrategy;

  constructor(private adMessageService: AdMessageService,
    private templateRef: TemplateRef<any>,
    private injector: Injector
  ) {
    this.rootNode = this.templateRef.elementRef.nativeElement as HTMLDivElement;
  }


  openPanel() {
    let pos = this.adMessageService
      .getPositionStrategy(this.templateRef.elementRef, [
        {
          original:
            { originX: 'start', originY: 'top' },
          overlay: { overlayX: 'start', overlayY: 'top' }
        },
        {
          original:
            { originX: 'start', originY: 'bottom' },
          overlay: { overlayX: 'start', overlayY: 'bottom' }
        }
      ]);
    const { api, componentRef } = this.adMessageService.openPanelComponent({
      component: AdSearchListComponent,
      config: { positionStrategy: pos },
      injector: this.injector,
      hideOnDropbackClick: true,
      inputs: { options: this.options }
    });
    this.panel = componentRef.instance as ControlValueAccessor;
    this.panel.registerOnChange(this.onChange);
    this.panel.registerOnTouched(this.onTouch);
    this.panel.writeValue(this.value);
    this.panel.setDisabledState(this.disabled);
  }



  writeValue(obj: any): void {
    this.value = obj;
    this.panel?.writeValue(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.panel?.setDisabledState(isDisabled);
  }

}
